import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'

import { DocumentManagementNCIPage } from './DocumentManagementNCI/DocumentManagementNCIPage'
import { DocumentManagementNonNCIPage } from './DocumentManagementNonNCI/DocumentManagementNonNCI.page'

export const DocumentManagementIdentificationPage: React.FC = () => {
  const { account } = useAccountReadContext()

  const { t } = useTranslation()

  return (
    <React.Fragment>
      {account?.visibilityConfiguration?.hasNCI && <DocumentManagementNCIPage />}
      {!account?.visibilityConfiguration?.hasNCI && (
        <DocumentManagementNonNCIPage documentTitle={t('Sign up.Identification')} />
      )}
    </React.Fragment>
  )
}
